import { SVGProps, Ref, forwardRef } from 'react';

export const BellCrossedOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8 .5c5.216 0 6.145 7.543 6.303 10.83l-1.52-1.52a22 22 0 0 0-.477-2.813c-.353-1.454-.875-2.775-1.605-3.706-.693-.884-1.542-1.391-2.7-1.391-.916 0-1.638.317-2.243.886l-.99-.99C5.602 1 6.66.5 8 .5"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.887 3.897 3.872 2.882 1.491.5.5 1.49l2.673 2.674c-1.101 2.442-1.401 5.515-1.48 7.27q-.019.452-.023.774c-.007.396 0 .625 0 .625h3.776c.26 1.47 1.01 2.667 2.557 2.667 1.548 0 2.297-1.198 2.557-2.667h1.282L14.51 15.5l.991-.99zm5.555 7.536-6.2-6.2c-.214.551-.395 1.146-.546 1.764-.349 1.435-.507 2.89-.577 3.997q-.015.231-.024.44zm-3.567 1.4c.068.29.159.54.269.737.207.374.44.53.86.53.417 0 .651-.156.859-.53.11-.198.2-.447.268-.737z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BellCrossedOutlinedSize16Glyph.displayName = 'BellCrossedOutlinedSize16Glyph';
